import * as yup from "yup";
import { TFunction } from "i18next";

// yup-схема временных закреплений: РМ не обязателен, минимум 1 дилер обязателен.
// Даты не валидируем (строка может быть без периода).
export function getTemporaryAssignmentsValidation(t: TFunction) {
  return yup.object().shape({
    assignments: yup.array().of(
      yup.object().shape({
        permanentRmId: yup.number().nullable().notRequired(),
        dealers: yup
          .array()
          .of(yup.number())
          .min(1, t("users.select_dealers"))
          .required(t("users.select_dealers")),
      }),
    ),
  });
}
